export default function scrollTrigger ( {
	target, top = 0, bottom = 0, markers, animate, centered, over, revise = true,
} ) {
	let targets = document.querySelectorAll( target );
	let h = window.innerHeight;
	let render = false;

	if ( markers ) {
		let start = document.createElement( 'div' );
		let end = document.createElement( 'div' );

		start.classList.add( 'start' );
		start.setAttribute( 'style', `bottom:${bottom}%; border-top: 5px dashed green;position:fixed;left:0;width:100vw` );
		end.classList.add( 'end' );
		end.setAttribute( 'style', `top:${top}%; border-top: 5px dashed red;position:fixed;left:0;width:100vw` );
		document.querySelector( 'body' ).append( start, end );
	}

	targets && targets.forEach( ( target ) => {
		let run = false;

		window.addEventListener( 'scroll',  anim );
		window.addEventListener( 'load',  anim );

		function anim () {
			let viewClass = [
				'in-before',
				'in-after',
				'in-view',
			];
			let i = 0;
			let box = target.getBoundingClientRect();
			let from = ( h ) * ( 100 - bottom ) / 100;
			let to = ( h - ( over ? box.height * 2 : 0 ) ) * top / 100;
			let change = box.top + box.height - to;
			let progress = change / ( from - to );

			progress = 1 - Math.max( 0, Math.min( 1, progress ) );

			if ( !render ) {
				render = true;
				requestAnimationFrame( function () {
					i = [
						0,
						1,
					].includes( progress ) ? progress : 2;

					if ( !target.classList.contains( viewClass[ i ] ) ) {
						target.classList.remove( ...viewClass );
						target.classList.add( viewClass[ i ] );
					}

					if ( progress > 0 ) {
						target.classList.add( 'is-viewed' );
					}

					!run && animate && animate( target, centered ? .5 - progress : progress );

					if ( progress > 0 && !revise ) {
						run = true;
					}
					render = false;
				} );
			}
		}
	} );
}
